<section class="threshold-warning-modal" role="document">
  <button
    type="button"
    class="threshold-warning-modal__close"
    [attr.aria-label]="'promotions.detail.thresholdWarning.close' | translate"
    (click)="close()"
  >
    <img src="assets/img/promotions/detail/modal-close-linear.svg" alt="" aria-hidden="true" />
  </button>

  <div class="threshold-warning-modal__content">
    <span class="threshold-warning-modal__icon" aria-hidden="true">!</span>
    <div class="threshold-warning-modal__copy">
      <h2>{{ 'promotions.detail.thresholdWarning.title' | translate }}</h2>
      <p>{{ 'promotions.detail.thresholdWarning.description' | translate }}</p>
    </div>
  </div>

  <div class="threshold-warning-modal__actions">
    <korviu-button class="threshold-warning-modal__action" color="ghost" size="large" (click)="close()">
      {{ 'promotions.detail.thresholdWarning.contactUs' | translate }}
    </korviu-button>
    <korviu-button class="threshold-warning-modal__action" color="tertiary" size="large" (click)="completeForm()">
      {{ 'promotions.detail.thresholdWarning.completeForm' | translate }}
    </korviu-button>
  </div>
</section>
